import { describe, getJson } from "./client";

export interface SnapshotPosition {
	assetId: string;
	protocol: string;
	vaultAddress: string;
	balance: string;
	decimals: number;
	pricePerUnitUsdc: string;
	valueUsdcRaw: string;
	weight: string;
	expectedNetApy: string;
	exitTimeDays: number;
	maturity: string | null;
	lastUpdate: string;
	lastTxHash: string;
}

export interface SnapshotUnquotedEntry {
	protocol: string;
	vaultAddress: string | null;
	balance: string;
	reason: "missing_vault_address" | "vault_not_registered" | "no_quote";
}

export interface PortfolioSnapshotResponse {
	wallet: string;
	asOf: string;
	totalValueUsdcRaw: string;
	/** Free USDC sitting in the wallet, counted in `totalValueUsdcRaw`. */
	cashUsdcRaw: string;
	positionCount: number;
	positions: SnapshotPosition[];
	unquotedEntries: SnapshotUnquotedEntry[];
}

/** No wallet → worker uses its `KAM_WALLET_ADDRESS` default. */
export async function fetchPortfolioSnapshot(
	wallet?: string,
): Promise<PortfolioSnapshotResponse> {
	const url = wallet
		? `/info/portfolio/${wallet}/snapshot`
		: "/info/portfolio/snapshot";
	const body = await getJson<unknown>(url);
	if (!isSnapshotResponse(body)) {
		throw new Error(
			`${url} returned an unexpected shape (got ${describe(body)}; expected a PortfolioSnapshotResponse). Check route order in src/main.ts.`,
		);
	}
	return body;
}

function isSnapshotResponse(v: unknown): v is PortfolioSnapshotResponse {
	if (v == null || typeof v !== "object") return false;
	const o = v as Record<string, unknown>;
	return (
		typeof o.wallet === "string" &&
		Array.isArray(o.positions) &&
		Array.isArray(o.unquotedEntries)
	);
}
